import ApiService from './ApiService';
import { buildCdnUrl, CDN_BASE_URL, normalizeCdnUrl } from './CdnUtils';

const CDN_URL = CDN_BASE_URL;


const ContentService = {

    fetchVideo: async (privateId) => {

        try {

            const optimalServerData = await ApiService.getOptimalServer(privateId);
     

            console.log("obtaining watch url")
           
            console.log("set watch url")
            if (optimalServerData.data === "no-cache") {
               return buildCdnUrl(CDN_URL, `content/directWatch?privateId=${privateId}`);
            }
            else {
                const serverUrl = normalizeCdnUrl(optimalServerData.data);
                const animeData = await ApiService.getWatchSession(privateId, serverUrl);
                return buildCdnUrl(serverUrl, `content/watch/${animeData.data}`);
            }


        } catch (error) {
            console.error('Error fetching anime list:', error);
        }
    }

}
export default ContentService;
